import React from "react";
import "./InfoCard.css";

const InfoCard = ({ title, description, imageUrl }) => {
  return (
    <div className="info-card d-flex flex-column align-items-center justify-content-start">
      <div className="card-image">
        <img src={imageUrl} alt={title} loading="lazy" />
      </div>
      <div className="intro-card-content d-flex flex-column align-items-center">
        <div className="info-heading">{title}</div>
        <div className="info-desc">{description}</div>
      </div>
    </div>
  );
};

export default InfoCard;
